module.exports = __webpack_public_path__ + "static/plan-cc20aaeec4075e34c21de208bcda24e5.png";